import { useCallback, useMemo } from 'react';
import { createApiClient } from '@/core/api';
import { CUSTOMER_ENDPOINTS } from '../constants';
import type { CustomerProductPurchasesListResponse } from '../models/customerProductPurchase.model';
import { normalizeCustomerProductPurchasesListBody } from '../utils/customerProductPurchaseApi.mapper';

const DEFAULT_PAGE = 1;
const DEFAULT_LIMIT = 1000;

export const useCustomerProductPurchaseService = () => {
  const apiClient = useMemo(
    () => createApiClient({ isMock: false }),
    []
  );

  const listProductPurchases = useCallback(
    async (
      customerId: string,
      page = DEFAULT_PAGE,
      limit = DEFAULT_LIMIT
    ): Promise<CustomerProductPurchasesListResponse> => {
      const response = await apiClient.get<unknown>(
        CUSTOMER_ENDPOINTS.PRODUCT_PURCHASES(customerId),
        { params: { page, limit } }
      );
      return normalizeCustomerProductPurchasesListBody(response.data);
    },
    [apiClient]
  );

  return { listProductPurchases };
};
